document.addEventListener('DOMContentLoaded', () => {
  const targetNode = document.body;

  const valueProps = {
    '30-day-guarantee': {
      link: 'https://cdn.shopify.com/s/files/1/0549/5082/2118/files/30dayguarantee.png?v=1718196970',
      text: '30 day <br> guarantee',
    },
    'paraben-free': {
      link: 'https://cdn.shopify.com/s/files/1/0549/5082/2118/files/parabenfree.png?v=1718197087',
      text: 'paraben <br> free',
    },
    'fast-delivery': {
      link: 'https://cdn.shopify.com/s/files/1/0549/5082/2118/files/fastdelivery.png?v=1718197070',
      text: 'fast <br> delivery',
    },
  };

  function createValueDivs(props) {
    const template = document.getElementById('value-prop-template').content;

    return Object.keys(props).map((key) => {
      const value = props[key];
      const clone = document.importNode(template, true);

      const valuePropWrapper = clone.querySelector('.value-prop');
      valuePropWrapper.id = `${key}`;

      const valuePropImage = clone.querySelector('.value-prop-image');
      valuePropImage.src = value.link;

      const valuePropText = clone.querySelector('span');
      valuePropText.innerHTML = value.text;

      return valuePropWrapper;
    });
  }

  function createValueSection(props, location) {
    let valuePropsSec = document.querySelector('.value-props-section');
    if (valuePropsSec) return;

    const valuePropsSection = document.createElement('div');
    valuePropsSection.classList.add('value-props-section');
    const valueProps = createValueDivs(props);
    valuePropsSection.innerHTML = '';
    valueProps.forEach((div) => {
      valuePropsSection.appendChild(div);
    });

    const sideCart = document.querySelector('#CartPopup');

    if (location === 'top') {
      const sideCartBody = sideCart.querySelector('.upcart-cart-body.styles_CartPreview__body__xEFk6');
      const sideCartFirstChild = sideCartBody.firstChild;
      sideCartBody.insertBefore(valuePropsSection, sideCartFirstChild);
    } else {
      sideCart.querySelector('.styles_CartPreview__card__KX-WB').appendChild(valuePropsSection);
    }
  }

  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const sideCart = document.querySelector('#CartPopup');
        if (sideCart) {
          const dataAttribute = 'data-side-cart-incentivized-messaging';

          const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === dataAttribute) {
                const testVariation = targetNode.getAttribute(dataAttribute);
                if (testVariation === 'a') {
                  console.log('Original');
                } else if (testVariation === 'b') {
                  const location = 'top';
                  createValueSection(valueProps, location);
                } else if (testVariation === 'c') {
                  const location = 'bottom';
                  createValueSection(valueProps, location);
                }
              }
            }
          };

          const dataObserver = new MutationObserver(callback);
          const config = { attributes: true };
          dataObserver.observe(targetNode, config);

          observer.disconnect();
          break;
        }
      }
    }
  });

  const config = { childList: true, subtree: true };
  observer.observe(targetNode, config);
});
